import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { numberThousandsComma } from '@/utils/numberThousandsComma';
import { greenChartSettings } from './chartSettings';
import Highcharts from 'highcharts';
import { getGreenPowerApi } from '@/api/energy';
import { isNumber } from '@/utils/is';

import clonedeep from 'lodash.clonedeep';
var defaultGreenData = {
  本月外購電力: {
    ratio: '-',
    value: '-'
  },
  本月綠電自發自用: {
    ratio: '-',
    value: '-'
  },
  本月餘電躉售: {
    ratio: '-',
    value: '-'
  }
};
export default {
  name: 'OverviewGreenPower',
  props: {
    selectedFieldName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      greenData: defaultGreenData,
      greenChartOptions: _objectSpread(_objectSpread({}, clonedeep(greenChartSettings)), {}, {
        series: []
        // series: [
        //   {
        //     type: 'column',
        //     name: '外購電力',
        //     data: []
        //   },
        //   {
        //     type: 'column',
        //     name: '綠電自發自用',
        //     data: []
        //   },
        //   {
        //     type: 'line',
        //     name: '餘電躉售',
        //     data: []
        //   }
        // ]
      })
    };
  },
  watch: {
    selectedFieldName: function selectedFieldName() {
      this.getGreenPowerData();
    }
  },
  methods: {
    observeElementSize: function observeElementSize() {
      this.resizeObserver = new ResizeObserver(function (_entries) {
        Highcharts.charts.forEach(function (chart) {
          if (chart && chart.renderTo.id === 'greenChartId') chart.reflow();
        });
      });
      this.resizeObserver.observe(this.$refs.viewRef);
    },
    clearGreenDataAndChart: function clearGreenDataAndChart() {
      this.greenData = defaultGreenData;
      this.greenChartOptions.xAxis.categories = [];
      this.greenChartOptions.series = [];
    },
    setGreenData: function setGreenData(data) {
      var buyPowerRatio = data.buyPowerRatio,
        buyPower = data.buyPower,
        selfPowerRatio = data.selfPowerRatio,
        selfPower = data.selfPower,
        sellPowerRatio = data.sellPowerRatio,
        sellPower = data.sellPower;
      this.greenData = {
        本月外購電力: {
          ratio: isNumber(buyPowerRatio) ? isNumber(Math.round(buyPowerRatio * 100) / 100) : '-',
          value: isNumber(buyPower) ? numberThousandsComma(Math.round(buyPower * 100) / 100) : '-'
        },
        本月綠電自發自用: {
          ratio: isNumber(selfPowerRatio) ? Math.round(selfPowerRatio * 100) / 100 : '-',
          value: isNumber(selfPower) ? numberThousandsComma(Math.round(selfPower * 100) / 100) : '-'
        },
        本月餘電躉售: {
          title: '本月餘電躉售',
          ratio: isNumber(sellPowerRatio) ? Math.round(sellPowerRatio * 100) / 100 : '-',
          value: isNumber(sellPower) ? numberThousandsComma(Math.round(sellPower * 100) / 100) : '-'
        }
      };
    },
    setGreenChart: function setGreenChart(chartData) {
      var _this = this;
      var seriesContents = [{
        name: '外購電力',
        dataKey: 'buyPower',
        type: 'column'
      }, {
        name: '綠電自發自用',
        dataKey: 'selfPower',
        type: 'column'
      }, {
        name: '餘電躉售',
        dataKey: 'sellPower',
        type: 'line'
      }];
      this.greenChartOptions.xAxis.categories = chartData.map(function (o) {
        return o.date;
      });
      seriesContents.forEach(function (s) {
        _this.greenChartOptions.series.push({
          type: s.type,
          name: s.name,
          data: chartData.map(function (o) {
            return Math.round(o[s.dataKey] * 100) / 100;
          })
        });
        // this.greenChartOptions.series[idx].type = s.type
        // this.greenChartOptions.series[idx].name = s.name
        // this.greenChartOptions.series[idx].data = chartData.map(
        //   (o) => Math.round(o[s.dataKey] * 100) / 100
        // )
      });
    },
    getGreenPowerData: function getGreenPowerData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, _res$data$data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.clearGreenDataAndChart();
                _context.prev = 1;
                _context.next = 4;
                return getGreenPowerApi(_this2.selectedFieldName);
              case 4:
                res = _context.sent;
                if (!res.data.success) {
                  _context.next = 10;
                  break;
                }
                if (!(res.data.msg === 'no data')) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return", _this2.$swal('尚無資料'));
              case 8:
                _this2.setGreenData(res.data.data);
                _this2.setGreenChart((_res$data$data = res.data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.chartData);
              case 10:
                _context.next = 15;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);
                console.log('getGreenPowerData error', _context.t0);
              case 15:
                _context.prev = 15;
                // 有資料後 再設定 chart height 否則 chart height 會是 0
                _this2.resizeCharts();
                return _context.finish(15);
              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 12, 15, 18]]);
      }))();
    },
    resizeCharts: function resizeCharts() {
      var _this3 = this;
      // chart height
      this.$nextTick(function () {
        var viewWidth = _this3.$refs.viewRef.clientWidth;
        // console.log('green viewWidth -------------', viewWidth)
        var viewHeight = _this3.$refs.viewRef.clientHeight;
        // 視窗 1440 時 viewWidth = 1288
        if (viewWidth > 1288) {
          // const cardHeight =
          //   this.$refs.cardGroupRef.getBoundingClientRect().height

          // console.log('green viewHeight', viewHeight)
          // console.log('green cardHeight', cardHeight)
          // this.greenChartOptions.chart.height =
          //   viewHeight - cardHeight - 25 - 42
          _this3.greenChartOptions.chart.height = viewHeight - 258 - 25 - 42;
          // -card -gap -padding border 2

          return;
        }
        _this3.greenChartOptions.chart.height = viewHeight - 215 - 25 - 42;
      });
    }
  },
  created: function created() {
    window.addEventListener('resize', this.resizeCharts);

    // api
    // 有 keep alive 只進入頁面執行一次, watch 的不會執行
    this.getGreenPowerData();
  },
  mounted: function mounted() {
    this.observeElementSize();
  },
  beforeDestroy: function beforeDestroy() {
    this.resizeObserver.disconnect();
    window.removeEventListener('resize', this.resizeCharts);
  }
};